import React, { useState, useEffect, useRef } from 'react';
import AudioPlayer from 'react-h5-audio-player';
import { DownloadIcon } from '@heroicons/react/solid';
// TODO: add remove button
const AudioPlayerInput: React.FC<{
  value: string;
  headercomponent?: JSX.Element;
  fileName?: string;
}> = ({ value, fileName }) => {
  const [playbackRate, setPlaybackRate] = useState(1);
  const audioPlayer = useRef<AudioPlayer>(null);

  useEffect(() => {
    setPlaybackRate(audioPlayer.current?.audio.current?.playbackRate ?? 1);
  }, [audioPlayer]);

  useEffect(() => {
    if (audioPlayer.current?.audio.current?.playbackRate != undefined)
      audioPlayer.current.audio.current.playbackRate = playbackRate;
  }, [playbackRate]);

  return (
    <AudioPlayer
      autoPlayAfterSrcChange={false}
      autoPlay={false}
      src={value}
      ref={audioPlayer}
      header={
        <div className="flex justify-start w-full">
          {fileName ? (
            <a href={value} download={fileName}>
              <DownloadIcon className="w-5" />
            </a>
          ) : (
            <a href={value} download>
              <DownloadIcon className="w-5" />
            </a>
          )}
        </div>
      }
      style={{
        direction: 'ltr',
      }}
      footer={
        <div
          style={{
            display: 'flex',
            padding: '.5em 0',
            gap: '5px',
          }}
        >
          <label
            style={{
              flex: 1,
            }}
          >
            Speed:
          </label>
          <input
            style={{
              flex: 5,
            }}
            type="range"
            id="pbrate"
            min=".5"
            max="3"
            value={playbackRate}
            onChange={(e) => {
              setPlaybackRate(parseFloat(e.currentTarget.value));
            }}
            step=".1"
          />
          <span
            style={{
              flex: 1,
              textAlign: 'center',
            }}
          >
            {audioPlayer.current?.audio.current?.playbackRate ?? 1}
          </span>
        </div>
      }
    />
  );
};

export default AudioPlayerInput;
